import { getMasterContactIdFromScreenPop } from "../../utils/index.js";

export class WorkItemEvent {
  constructor(json) {
    this.type = json.Type;
    this.contactId = json.ContactID;
    this.status = json.Status;
    this.workItemId = json.WorkItemId;
    this.workItemPayload = json.WorkItemPayload;
    this.workItemType = json.WorkItemType;
    this.agentId = json.AgentId;
    this.skillId = json.SkillId;
    this.startTimeUTC = json.StartTimeUTC;
    this.lastStateChangeTimeUTC = json.LastStateChangeTimeUTC;
    this.screenPopUrl = json.ScreenPopUrl;
    this.screenPopVariables = json.ScreenPopUrlVariables;
    this.refusalTimeout = json.RefusalTimeout;
    this.finalState = String(json.FinalState).toLowerCase() === "true";
    this.disconnectCode = json.DisconnectCode;
  }

  get description() {
    return `${this.type} #${this.contactId} -> ${this.status}`;
  }

  get referenceNumber() {
    return (
      getMasterContactIdFromScreenPop(this.screenPopVariables) ??
      getMasterContactIdFromScreenPop(this.screenPopUrl)
    );
  }
}
